import Weekly from './weekly';
import Monthly from './monthly';

export default {
    Weekly,
    Monthly
}